import React from "react";

import Popup from "./Popup";

const PopupSelectSocialMedia = props => {
  const { trigger, setTrigger, children } = props;

  return (
    <Popup title="Selecionar rede social" trigger={trigger} setTrigger={setTrigger}>
      <div className="sm-body">
        {children}
      </div>
    </Popup>
  );
}

export default PopupSelectSocialMedia;